/******************************************
 *  Author : Miya.Ren@globalpay.com
 *  Created On : 9/19/2025, 3:03:42 PM
 *  File : Home.js
 *******************************************/

import { useEffect,useState } from "react";

function Home() {
  const [hpsSelectedProfile] = useState(JSON.parse(localStorage.getItem("hps-selected-profile")));
  const [appIsLogin] = useState(localStorage.getItem("appIsLogin"));

  useEffect(() => {
    if (!appIsLogin) {
      console.log("No idp_token found, redirecting to login");
      window.location.href = "/mfa/login";
    }
  }, [appIsLogin]);

  return (
    <div className="App">
      {hpsSelectedProfile && (
        <div>
          <h1>Welcome, {hpsSelectedProfile.firstName}!</h1>
          <p>Your profiles:</p>
          <p>{hpsSelectedProfile.firstName} {hpsSelectedProfile.lastName} - {hpsSelectedProfile.email}</p>
        </div>
      )}
    </div>
  );
}

export default Home;
